import {useCallback, Fragment} from 'react';
import {isTouch} from 'utils/platform';
import {Platform} from 'react-native';

import type {ReactNode, MouseEvent} from 'react';

interface MouseProps {
  children: ReactNode;
  onDoubleClick?(event: MouseEvent): void;
  onContextMenu?(event: MouseEvent): void;
}

export function Mouse(props: MouseProps) {
  const doubleClick = useCallback((e: MouseEvent) => {
    if (props.onDoubleClick) {
      e.stopPropagation();
      props.onDoubleClick(e);
    }
  }, [props.onDoubleClick]);

  const contextMenu = useCallback((e: MouseEvent) => {
    if (props.onContextMenu) {
      e.preventDefault();
      e.stopPropagation();
      props.onContextMenu(e);
    }
  }, [props.onContextMenu]);

  if (Platform.OS !== 'web') {
    return (
      <Fragment>{props.children}</Fragment>
    );
  }

  return (
    <div
      onDoubleClick={doubleClick}
      onContextMenu={!isTouch() ? contextMenu : undefined}
      style={{display: 'flex', flex: 1, height: '100%'}}>
      {props.children}
    </div>
  );
}
